import React from "react";

import {
  RideModal,
  RideModalContent,
  RideActionableCardSelector,
  RideRadioButton,
} from "@rimac-seguros/ride-system-components";

import "./styles.scss";

export const ModalRadioList = ({
  list = [],
  isOpen,
  setIsOpen,
  name,
  setValue,
  value,
  title,
}) => {
  const handleSelect = (e) => {
    setValue(name, String(e.target?.value));
    setIsOpen(false);
  };

  return (
    <RideModal
      variant="new"
      size="medium"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <RideModalContent>
        <div>
          <div className="modal-radio-list">
            {list.map((option) => {
              const isChecked = String(value) === String(option?.value);
              return (
                <div
                  key={option?.value}
                  className="border-b border-ride-sys-color-border-default"
                >
                  <RideActionableCardSelector
                    className="modal-radio-list-card modal-radio-list-no-transform"
                    onChange={handleSelect}
                    control={
                      <RideRadioButton
                        title={option?.label}
                        name={name}
                        checked={isChecked}
                        value={option?.value}
                        className="modal-radio-list_option"
                        onChange={handleSelect}
                        readOnly
                      />
                    }
                  >
                    <div>
                      <p>{option.label}</p>
                    </div>
                  </RideActionableCardSelector>
                </div>
              );
            })}
          </div>
        </div>
      </RideModalContent>
    </RideModal>
  );
};
